import * as actionTypes from "../action-types";

//! Partner
export const getPartners = payload => ({ type: actionTypes.GET_PARTNERS, payload });
export const getPartnerById = payload => ({ type: actionTypes.GET_PARTNER_BY_ID, payload });
export const createPartner = payload => ({ type: actionTypes.CREATE_PARTNER, payload });
export const updatePartner = payload => ({ type: actionTypes.UPDATE_PARTNER, payload });
export const deletePartner = payload => ({ type: actionTypes.DELETE_PARTNER, payload });

//* Customer
export const getCustomerByPartnerId = payload => ({ type: actionTypes.GET_CUSTOMER_BY_PARTNERID, payload });

//! Partner Report Wallet
export const getPartnerReportWallets = payload => ({ type: actionTypes.GET_PARTNER_REPORT_WALLETS });
export const createPartnerReportWallet = payload => ({ type: actionTypes.CREATE_PARTNER_REPORT_WALLET, payload });
export const updatePartnerReportWallet = payload => ({ type: actionTypes.UPDATE_PARTNER_REPORT_WALLET, payload });
export const deletePartnerReportWallet = payload => ({ type: actionTypes.DELETE_PARTNER_REPORT_WALLET, payload });
//! Affiliate by Partner (hierarchy drill-down)
export const getAffiliatesByPartnerId = payload => ({ type: actionTypes.GET_AFFILIATE_BY_PARTNERID, payload });
export const getCustomersByAffiliateId = payload => ({ type: actionTypes.GET_CUSTOMER_BY_AFFILIATEID, payload });
